


























































































































































import * as _ from 'lodash';
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import {
  PriceRangeFilterDto,
  ProductFacetsDto,
  ProductPropertyDto,
  ProductSearchFilterDto,
} from '@/api';
import SortSelection from '@/views/search/filter/SortSelection.vue';
import SearchFilterOption from '@/views/search/filter/SearchFilterOption.vue';
import VueSlider from 'vue-slider-component';
import SmoothShow from '@/views/common/SmoothShow.vue';
import KeycloakStore from '@/stores/user/keycloak.store';
import { getModule } from 'vuex-module-decorators';
import PriceFilterControl from '@/views/search/filter/PriceFilterControl.vue';
import MobileSortSelection from '@/views/search/filter/MobileSortSelection.vue';
import { SortSetting } from '@/util/SortUtils';

@Component({
  components: {MobileSortSelection, PriceFilterControl, SmoothShow, SearchFilterOption, SortSelection, VueSlider},
})
export default class SearchFilterControl extends Vue {
  private keycloakStore: KeycloakStore = getModule(KeycloakStore, this.$store);
  public open = false;
  public mobileSortOpen = false;
  private activeMap: Map<string, boolean> = new Map();

  @Model('change')
  public filter!: ProductSearchFilterDto;

  @Prop({required: true})
  public facets!: ProductFacetsDto;

  @Prop({required: true})
  public sortOptions!: SortSetting[];

  @Prop({required: true})
  public currentSortSetting!: SortSetting;

  public get isLoggedIn(): boolean {
    return this.keycloakStore.authenticated;
  }

  public get isOfferPriceFilterActive(): boolean {
    return this.filter.offerPricesOnly ?? false;
  }

  public get isTreasuresFilterActive(): boolean {
    return this.findPropertyIndex(ProductPropertyDto.UNSEREKOSTBARKEITEN) > -1;
  }

  public get sortedAttributes() {
    return _.orderBy(this.facets.attributes, ['key'], ['desc']);
  }

  public get priceRangeOrNull(): PriceRangeFilterDto | null {
    return this.filter.priceRange ?? null;
  }

  public updatePriceFilter(newValue?: PriceRangeFilterDto) {
    const changedFilter = _.cloneDeep(this.filter);
    changedFilter.priceRange = newValue;
    this.$emit('change', changedFilter);
  }

  public isAttributeSelected(key: string, value: string): boolean {
    return this.findAttributeIndex(key, value) > -1;
  }

  public toggleAttribute(key: string, value: string) {
    const existing = this.findAttributeIndex(key, value);
    const changedFilter = _.cloneDeep(this.filter);
    if (existing > -1) {
      changedFilter.attributes?.splice(existing, 1);
    } else if (changedFilter.attributes) {
      changedFilter.attributes.push({key, value});
    } else {
      changedFilter.attributes = [{key, value}];
    }
    this.$emit('change', changedFilter);
  }

  public isPropertySelected(key: ProductPropertyDto): boolean {
    return this.findPropertyIndex(key) > -1;
  }

  public toggleProperty(key: ProductPropertyDto) {
    const existing = this.findPropertyIndex(key);
    const changedFilter = _.cloneDeep(this.filter);
    if (existing > -1) {
      changedFilter.properties?.splice(existing, 1);
    } else if (changedFilter.properties) {
      changedFilter.properties.push(key);
    } else {
      changedFilter.properties = [key];
    }
    this.$emit('change', changedFilter);
  }

  private resetFilter() {
    const changedFilter = {categoryId: this.filter.categoryId};
    this.$emit('change', changedFilter);
  }

  private toggleMenu(key: string) {
    this.activeMap.set(key, !this.activeMap.get(key));
    this.$forceUpdate();
  }

  private isMenuActive(key: string) {
    return this.activeMap.get(key);
  }

  private findAttributeIndex(key: string, value: string) {
    return this.filter.attributes?.findIndex((a) => a.key === key && a.value === value) ?? -1;
  }

  private findPropertyIndex(key: ProductPropertyDto) {
    return this.filter.properties?.indexOf(key) ?? -1;
  }

  public toggleOfferPriceFilter() {
    const changedFilter = _.cloneDeep(this.filter);
    changedFilter.offerPricesOnly = !this.isOfferPriceFilterActive;
    this.$emit('change', changedFilter);
  }

  public toggleTreasuresFilter() {
    this.toggleProperty(ProductPropertyDto.UNSEREKOSTBARKEITEN);
  }

  public updateSortSetting(sortSettingId: string) {
    this.$emit('changeSort', sortSettingId);
  }

  public closeMobileSort() {
    this.mobileSortOpen = false;
  }
}
